import React from 'react';
import { Link } from 'react-router-dom';
import Project from '../components/Project';

const Projects = () => {
  const projects = [
    {
      name: 'skepa-lang',
      coverImage: '/assets/skepalang.png',
      description: 'A modern programming language that combines simplicity with powerful features, designed to make development more efficient and enjoyable.',
      technologies: ['Compiler Design', 'Syntax Analysis', 'VM Implementation'],
      status: 'Active Development',
      links: [
        { label: 'GitHub', url: 'https://github.com/AayushMainali-Github/skepa-lang' },
      ],
    },
    {
      name: 'skepa-db',
      coverImage: '/assets/skepadb.png',
      description: 'A high-performance database management system built for scalability, reliability, and ease of use in modern application development.',
      technologies: ['Database Design', 'Query Optimization', 'Distributed Systems'],
      status: 'Beta Release',
      links: [
        { label: 'GitHub', url: 'https://github.com/AayushMainali-Github/skepa-db' },
      ],
    },
  ];

  return (
    <main className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-dark mb-4">Our Projects</h1>
          <p className="text-lg text-secondary max-w-2xl mx-auto">
            Discover the innovative software solutions we've built. Each project represents our commitment to pushing the boundaries of technology.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <Link key={index} to={`/project/${project.name}`} className="block">
              <Project {...project} />
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Projects;